import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index';

import Mgr from '@/utils/SecurityService';

let mgr = new Mgr();

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page401 from '@/views/pages/Page401'
//import Page500 from '@/views/pages/Page500'
import Login from '@/views/pages/Login'
//import Register from '@/views/pages/Register'

const getViewReportRequiredPrivileges = (index) => {
    var reportTypeIds = store.state.common.listGroupReportTypes[index].reportTypeIds;
    var reportTypes = store.state.common.listReportSyncTypes.filter(x => reportTypeIds.indexOf(x.id) != -1);

    return reportTypes.map(x => 'ViewReport_' + x.table.substr(4));
};

Vue.use(Router)

var router = new Router({
    mode: 'hash', // Demo is living in GitHub.io, so required!
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            redirect: '/home',
            name: 'default',
            component: TheContainer,
            meta: { requiresAuth: true, label: 'Trang chủ' },
            children: [
                {
                    path: 'home',
                    meta: { requiresAuth: true },
                    component: () => import('@/views/home')
                },
                {
                    path: '/profile',
                    name: 'profile',
                    meta: { label: 'Thông tin tài khoản' },
                    component: () => import('@/views/pages/Profile')
                },
                {
                    path: 'system',
                    name: 'system',
                    redirect: '/system/users',
                    meta: { label: 'Quản trị hệ thống' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'users',
                            name: 'users',
                            redirect: '/system/users/list',
                            meta: { label: 'Người sử dụng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'user_list',
                                    meta: { label: 'Tra cứu, tìm kiếm người sử dụng', requiresAuth: true, requiresPrivileges: ['ViewUser'] },
                                    component: () => import('@/views/system/users/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_user',
                                    meta: { label: 'Thêm mới người sử dụng', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/system/users/create')
                                },
                                {
                                    path: ':userId',
                                    redirect: '/system/users/:userId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewUser', 'ManageUser'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'user_detail_info',
                                            meta: { label: 'Xem chi tiết người sử dụng', requiresAuth: true, requiresPrivileges: ['ViewUser', 'ManageUser'] },
                                            component: () => import('@/views/system/users/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'user_edit',
                                            meta: { label: 'Sửa người sử dụng', editing: true, requiresAuth: true, requiresPrivileges: ['ManageUser'] },
                                            component: () => import('@/views/system/users/detail')
                                        },
                                        {
                                            path: 'privileges',
                                            name: 'user_privileges',
                                            meta: { label: 'Phân quyền người sử dụng', requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/system/users/privileges')
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            path: 'roles',
                            name: 'roles',
                            redirect: '/system/roles/list',
                            meta: { label: 'Nhóm người dùng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'role_list',
                                    meta: { label: 'Tra cứu, tìm kiếm nhóm người dùng', requiresAuth: true, requiresPrivileges: ['ViewRole'] },
                                    component: () => import('@/views/system/roles/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_role',
                                    meta: { label: 'Thêm mới nhóm người dùng', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/system/roles/create')
                                },
                                {
                                    path: ':roleId',
                                    redirect: '/system/roles/:roleId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewRole', 'ManageRole'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'role_detail_info',
                                            meta: { label: 'Xem chi tiết nhóm người dùng', requiresAuth: true, requiresPrivileges: ['ViewRole', 'ManageRole'] },
                                            component: () => import('@/views/system/roles/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'role_edit',
                                            meta: { label: 'Sửa nhóm người dùng', editing: true, requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/system/roles/detail')
                                        },
                                        {
                                            path: 'privileges',
                                            name: 'role_privileges',
                                            meta: { label: 'Phân quyền cho nhóm người dùng', requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/system/roles/privileges')
                                        },
                                        {
                                            path: 'users',
                                            name: 'role_assign_users',
                                            meta: { label: 'Gán người dùng cho nhóm người dùng', requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/system/roles/users')
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            path: 'exploitation-users',
                            name: 'exploitation_users',
                            redirect: '/system/exploitation-users/list',
                            meta: { label: 'Tài khoản khai thác' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'exploitation_user_list',
                                    meta: { label: 'Tìm kiếm, tra cứu thông tin tài khoản cán bộ khai thác', requiresAuth: true, requiresPrivileges: ['ViewExploitationUser'] },
                                    component: () => import('@/views/system/exploitation-users/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_exploitation_user',
                                    meta: { label: 'Thêm mới tài khoản cán bộ khai thác', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/system/exploitation-users/create')
                                },
                                {
                                    path: ':exploitationUserId',
                                    redirect: '/system/exploitation-users/:exploitationUserId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewExploitationUser', 'ManageExploitationUser'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'exploitation_user_detail_info',
                                            meta: { label: 'Xem chi tiết tài khoản cán bộ khai thác', requiresAuth: true, requiresPrivileges: ['ViewExploitationUser', 'ManageExploitationUser'] },
                                            component: () => import('@/views/system/exploitation-users/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'exploitation_user_edit',
                                            meta: { label: 'Sửa tài khoản cán bộ khai thác', editing: true, requiresAuth: true, requiresPrivileges: ['ManageExploitationUser'] },
                                            component: () => import('@/views/system/exploitation-users/detail')
                                        },
                                        {
                                            path: 'privileges',
                                            name: 'exploitation_user_privileges',
                                            meta: { label: 'Phân quyền tài khoản cán bộ khai thác', requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/system/exploitation-users/privileges')
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            path: 'exploitation-roles',
                            name: 'exploitationroles',
                            redirect: '/system/exploitation-roles/list',
                            meta: { label: 'Nhóm tài khoản khai thác' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'exploitation_role_list',
                                    meta: { label: 'Tra cứu, tìm kiếm nhóm tài khoản đơn vị khai thác dữ liệu', requiresAuth: true, requiresPrivileges: ['ViewExploitationRole'] },
                                    component: () => import('@/views/system/exploitation-roles/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_exploitation_role',
                                    meta: { label: 'Thêm mới nhóm tài khoản đơn vị khai thác dữ liệu', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/system/exploitation-roles/create')
                                },
                                {
                                    path: ':exploitationRoleId',
                                    redirect: '/system/exploitation-roles/:exploitationRoleId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewExploitationRole', 'ManageExploitationRole'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'exploitation_role_detail_info',
                                            meta: { label: 'Xem chi tiết nhóm tài khoản đơn vị khai thác dữ liệu', requiresAuth: true, requiresPrivileges: ['ViewExploitationRole', 'ManageExploitationRole'] },
                                            component: () => import('@/views/system/exploitation-roles/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'exploitation_role_edit',
                                            meta: { label: 'Sửa nhóm tài khoản đơn vị khai thác dữ liệu', editing: true, requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/system/exploitation-roles/detail')
                                        },
                                        {
                                            path: 'privileges',
                                            name: 'exploitation_role_privileges',
                                            meta: { label: 'Phân quyền nhóm tài khoản đơn vị khai thác dữ liệu', requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/system/exploitation-roles/privileges')
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            path: 'sync-users',
                            name: 'sync_users',
                            redirect: '/system/sync-users/list',
                            meta: { label: 'Tài khoản đơn vị đồng bộ' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'syncuser_list',
                                    meta: { label: 'Tìm kiếm, tra cứu thông tin tài khoản đơn vị đồng bộ dữ liệu', requiresAuth: true, requiresPrivileges: ['ViewSyncUser'] },
                                    component: () => import('@/views/system/sync-users/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_syncuser',
                                    meta: { label: 'Thêm mới tài khoản đơn vị đồng bộ dữ liệu', requiresAuth: true, requiresPrivileges: ['ManageSyncUser'] },
                                    component: () => import('@/views/system/sync-users/create')
                                },
                                {
                                    path: ':syncUserId',
                                    redirect: '/system/sync-users/:syncUserId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewSyncUser', 'ManageSyncUser'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'sync_user_detail_info',
                                            meta: { label: 'Xem chi tiết tài khoản đơn vị đồng bộ dữ liệu', requiresAuth: true, requiresPrivileges: ['ViewSyncUser', 'ManageSyncUser'] },
                                            component: () => import('@/views/system/sync-users/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'sync_user_edit',
                                            meta: { label: 'Sửa tài khoản đơn vị đồng bộ dữ liệu', editing: true, requiresAuth: true, requiresPrivileges: ['ViewSyncUser', 'ManageSyncUser'] },
                                            component: () => import('@/views/system/sync-users/detail')
                                        },
                                        {
                                            path: 'privileges',
                                            name: 'sync_user_privileges',
                                            meta: { label: 'Phân quyền tài khoản đơn vị đồng bộ dữ liệu', requiresAuth: true, requiresPrivileges: ['ManageSyncUser'] },
                                            component: () => import('@/views/system/sync-users/privileges')
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            path: 'sync-roles',
                            name: 'sync-roles',
                            redirect: '/system/sync-roles/list',
                            meta: { label: 'Nhóm tài khoản đơn vị đồng bộ' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'syncrole_list',
                                    meta: { label: 'Tra cứu, tìm kiếm nhóm tài khoản đồng bộ dữ liệu', requiresAuth: true, requiresPrivileges: ['ViewSyncRole'] },
                                    component: () => import('@/views/system/sync-roles/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_syncrole',
                                    meta: { label: 'Thêm mới nhóm tài khoản đồng bộ dữ liệu', requiresAuth: true, requiresPrivileges: ['ManageSyncRole'], adminOnly: true },
                                    component: () => import('@/views/system/sync-roles/create')
                                },
                                {
                                    path: ':syncRoleId',
                                    redirect: '/system/sync-roles/:syncRoleId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewSyncRole', 'ManageSyncRole'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'sync_role_detail_info',
                                            meta: { label: 'Xem chi tiết nhóm tài khoản đồng bộ dữ liệu', requiresAuth: true, requiresPrivileges: ['ViewSyncRole', 'ManageSyncRole'] },
                                            component: () => import('@/views/system/sync-roles/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'sync_role_edit',
                                            meta: { label: 'Sửa nhóm tài khoản đồng bộ dữ liệu', editing: true, requiresAuth: true, requiresPrivileges: ['ViewSyncRole', 'ManageSyncRole'], adminOnly: true },
                                            component: () => import('@/views/system/sync-roles/detail')
                                        },
                                        {
                                            path: 'privileges',
                                            name: 'sync_role_privileges',
                                            meta: { label: 'Phân quyền nhóm tài khoản đồng bộ dữ liệu', requiresAuth: true, requiresPrivileges: ['ManageSyncRole'], adminOnly: true },
                                            component: () => import('@/views/system/sync-roles/privileges')
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            path: 'approved-users',
                            name: 'approved_users',
                            redirect: '/system/approved-users/list',
                            meta: { label: 'Duyệt người dùng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'approved_user_list',
                                    meta: { label: 'Tra cứu, tìm kiếm duyệt người dùng', requiresAuth: true, requiresPrivileges: ['ViewApprovedUser', 'ManageApprovedUser'] },
                                    component: () => import('@/views/system/approved-users/list')
                                },
                            ]
                        },
                        {
                            path: 'system-parameters',
                            name: 'system_parameters',
                            meta: { label: 'Thiết lập tham số hệ thống', requiresAuth: true },
                            component: () => import('@/views/system/system-parameters/create')
                        },
                        {
                            path: 'report-parameters',
                            name: 'report_parameters',
                            meta: { label: 'Thiết lập tham số báo cáo' },
                            component: () => import('@/views/system/report-parameters/create')
                        },
                        {
                            path: 'sync-parameters',
                            name: 'sync_parameters',
                            meta: { label: 'Thiết lập cấu hình đồng bộ dữ liệu' },
                            component: () => import('@/views/system/sync-parameters/index')
                        },
                        {
                            path: 'backups',
                            name: 'backups',
                            meta: { label: 'Sao lưu/phục hồi dữ liệu', requiresPrivileges: ['ManageBackup'] },
                            component: () => import('@/views/system/backups/index')
                        },
                        {
                            path: 'backup_data',
                            name: 'backup_data',
                            meta: { label: 'Sao lưu dữ liệu tài sản, báo cáo', requiresAuth: true, adminOnly: true },
                            component: () => import('@/views/system/backups/backup')
                        },
                        {
                            path: 'restore_data',
                            name: 'restore_data',
                            meta: { label: 'Phục hồi dữ liệu tài sản, báo cáo', requiresAuth: true, adminOnly: true },
                            component: () => import('@/views/system/backups/restore')
                        },
                        {
                            path: 'backup_config',
                            name: 'backup_config',
                            meta: { label: 'Sao lưu dữ liệu toàn hệ thống', requiresAuth: true, adminOnly: true },
                            component: () => import('@/views/system/backups/config')
                        },
                        {
                            path: 'field-mapping',
                            name: 'field_mapping',
                            redirect: '/system/field-mapping/index',
                            meta: { label: 'Cấu hình mapping dữ liệu tài sản', requiresAuth: true, adminOnly: true },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'index',
                                    name: 'field_mapping_index',
                                    meta: { label: 'Index', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/system/field-mapping/index')
                                },
                                {
                                    path: 'display',
                                    name: 'field_mapping_display',
                                    meta: { label: 'Preview', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/system/field-mapping/display')
                                }
                            ]
                        },
                        //{
                        //    path: 'asset-type-mappings',
                        //    name: 'asset_type_mappings',
                        //    meta: { label: 'Cấu hình nhóm tài sản lớn', requiresAuth: true, adminOnly: true },
                        //    component: () => import('@/views/system/asset-modules/index')
                        //}
                        {
                            path: 'report-request-parameter',
                            name: 'report_request_parameter',
                            redirect: '/system/report-request-parameter/list',
                            meta: { label: 'Cấu hình yêu cầu báo cáo định kỳ', requiresAuth: true, adminOnly: true },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'report_request_parameter_list',
                                    meta: { label: 'Tra cứu, tìm kiếm cấu hình yêu cầu báo cáo định kỳ', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/system/report-request-parameter/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_request_parameter',
                                    meta: { label: 'Thêm mới cấu hình yêu cầu báo cáo định kỳ', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/system/report-request-parameter/create')
                                },
                                {
                                    path: ':id',
                                    redirect: '/system/report-request-parameter/:id/detail',
                                    meta: { requiresAuth: true, adminOnly: true },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'request_parameter_detail_info',
                                            meta: { label: 'Xem chi tiết cấu hình yêu cầu báo cáo định kỳ', requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/system/report-request-parameter/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'request_parameter_edit',
                                            meta: { label: 'Sửa cấu hình yêu cầu báo cáo định kỳ', editing: true, requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/system/report-request-parameter/detail')
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'report-type-sync-data-source',
                            name: 'report_type_sync_data_source',
                            redirect: '/system/report-type-sync-data-source/list',
                            meta: { label: 'Cấu hình mapping báo cáo định kỳ/ đột xuất', requiresAuth: true, adminOnly: true },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'report_type_sync_data_source_list',
                                    meta: { label: 'Tra cứu, tìm kiếm cấu hình mapping báo cáo định kỳ/ đột xuất', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/system/report-type-sync-data-source/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_report_type_sync_data_source',
                                    meta: { label: 'Thêm mới cấu hình mapping báo cáo định kỳ/ đột xuất', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/system/report-type-sync-data-source/create')
                                },
                                {
                                    path: ':reportTypeId/:syncDataSourceId',
                                    redirect: '/system/report-type-sync-data-source/:reportTypeId/:syncDataSourceId/detail',
                                    meta: { requiresAuth: true, adminOnly: true },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'report_type_sync_data_source_detail_info',
                                            meta: { label: 'Xem chi tiết cấu hình mapping báo cáo định kỳ/ đột xuất', requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/system/report-type-sync-data-source/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'report_type_sync_data_source_edit',
                                            meta: { label: 'Sửa cấu hình mapping báo cáo định kỳ/ đột xuất', editing: true, requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/system/report-type-sync-data-source/detail')
                                        }
                                    ]
                                }
                            ]
                        },
                    ]
                },
                {
                    path: 'master-data',
                    name: 'master_data',
                    redirect: '/master-data/unit-types/',
                    meta: { label: 'Quản lý danh mục' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'sync-data-sources',
                            name: 'sync_data_sources',
                            redirect: '/master-data/sync-data-sources/list',
                            meta: { label: 'Phân loại đơn vị' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'sync_data_source_list',
                                    meta: { label: 'Tra cứu, tìm kiếm nguồn đồng bộ dữ liệu', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/master-data/sync-data-sources/list')
                                },
                                {
                                    path: 'create',
                                    name: 'sync_data_source_create',
                                    meta: { label: 'Thêm mới nguồn đồng bộ dữ liệu', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/master-data/sync-data-sources/create')
                                },
                                {
                                    path: ':syncDataSourceId',
                                    redirect: '/master-data/sync-data-sources/:syncDataSourceId/detail', meta: { requiresAuth: true, adminOnly: true },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'sync_data_source_detail_info',
                                            meta: { label: 'Xem chi tiết nguồn đồng bộ dữ liệu', requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/master-data/sync-data-sources/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'sync_data_source_edit',
                                            meta: { label: 'Sửa nguồn đồng bộ dữ liệu', editing: true, requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/master-data/sync-data-sources/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'unit-types',
                            name: 'unit_types',
                            redirect: '/master-data/unit-types/list',
                            meta: { label: 'Phân loại đơn vị' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'unit_type_list',
                                    meta: { label: 'Tra cứu, tìm kiếm phân loại đơn vị', requiresAuth: true, requiresPrivileges: ['ViewUnitType'] },
                                    component: () => import('@/views/master-data/unit-types/list-new')
                                },
                                {
                                    path: 'create',
                                    name: 'unit_type_create',
                                    meta: { label: 'Thêm mới phân loại đơn vị', requiresAuth: true, requiresPrivileges: ['ManageUnitType'] },
                                    component: () => import('@/views/master-data/unit-types/create')
                                },
                                //{
                                //    path: ':unitTypeId',
                                //    name: 'unit_type_edit',
                                //    meta: { label: 'Sửa', requiresAuth: true, requiresPrivileges: ['ViewUnitType', 'ManageUnitType'] },
                                //    component: () => import('@/views/master-data/unit-types/edit')
                                //},
                                {
                                    path: ':unitTypeId',
                                    redirect: '/master-data/unit-types/:unitTypeId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewUnitType', 'ManageUnitType'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'unit_type_detail_info',
                                            meta: { label: 'Xem chi tiết phân loại đơn vị', requiresAuth: true, requiresPrivileges: ['ViewUnitType', 'ManageUnitType'] },
                                            component: () => import('@/views/master-data/unit-types/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'unit_type_edit',
                                            meta: { label: 'Sửa phân loại đơn vị', editing: true, requiresAuth: true, requiresPrivileges: ['ViewUnitType', 'ManageUnitType'] },
                                            component: () => import('@/views/master-data/unit-types/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'units',
                            name: 'units',
                            redirect: '/master-data/units/list',
                            meta: { label: 'Đơn vị' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'national-budget-code-assignment',
                                    name: 'national_budget_code_assignment',
                                    meta: { label: 'Chuyển mã đơn vị quan hệ ngân sách', requiresAuth: true, requiresPrivileges: ['ManageUnit'] },
                                    component: () => import('@/views/master-data/units/national-budget-code-assignment')
                                },
                                {
                                    path: 'list',
                                    name: 'unit_list',
                                    meta: { label: 'Tra cứu, tìm kiếm đơn vị', requiresAuth: true, requiresPrivileges: ['ViewUnit'] },
                                    component: () => import('@/views/master-data/units/list-new')
                                },
                                {
                                    path: 'create',
                                    name: 'create_unit',
                                    meta: { label: 'Thêm mới đơn vị', requiresAuth: true, requiresPrivileges: ['ManageUnit'] },
                                    component: () => import('@/views/master-data/units/create')
                                },

                                //{
                                //    path: ':unitId',
                                //    name: 'unit_edit',
                                //    meta: { label: 'Sửa', requiresAuth: true, requiresPrivileges: ['ViewUnit', 'ManageUnit'] },
                                //    component: () => import('@/views/master-data/units/edit')
                                //}

                                {
                                    path: ':unitId',
                                    redirect: '/master-data/units/:unitId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewUnit', 'ManageUnit'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'unit_detail_info',
                                            meta: { label: 'Xem chi tiết đơn vị', requiresAuth: true, requiresPrivileges: ['ViewUnit', 'ManageUnit'] },
                                            component: () => import('@/views/master-data/units/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'unit_edit',
                                            meta: { label: 'Sửa đơn vị', editing: true, requiresAuth: true, requiresPrivileges: ['ViewUnit', 'ManageUnit'] },
                                            component: () => import('@/views/master-data/units/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'departments',
                            name: 'departments',
                            redirect: '/master-data/departments/list',
                            meta: { label: 'Bộ phận sử dụng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'department_list',
                                    meta: { label: 'Tra cứu, tìm kiếm bộ phận sử dụng', requiresAuth: true, requiresPrivileges: ['ViewDepartment'] },
                                    component: () => import('@/views/master-data/departments/list-new')
                                },
                                {
                                    path: 'create',
                                    name: 'create_department',
                                    meta: { label: 'Thêm mới bộ phận sử dụng', requiresAuth: true, requiresPrivileges: ['ManageDepartment'] },
                                    component: () => import('@/views/master-data/departments/create')
                                },
                                {
                                    path: ':departmentId',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewDepartment', 'ManageDepartment'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'department_detail_info',
                                            meta: { label: 'Xem chi tiết bộ phận sử dụng', requiresAuth: true, requiresPrivileges: ['ViewDepartment', 'ManageDepartment'] },
                                            component: () => import('@/views/master-data/departments/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'department_edit',
                                            meta: { label: 'Sửa bộ phận sử dụng', editing: true, requiresAuth: true, requiresPrivileges: ['ViewDepartment', 'ManageDepartment'] },
                                            component: () => import('@/views/master-data/departments/detail')
                                        }
                                    ]
                                },

                            ]
                        },
                        {
                            path: 'projects',
                            name: 'projects',
                            redirect: '/master-data/projects/list',
                            meta: { label: 'Dự án' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'project_list',
                                    meta: { label: 'Tra cứu, tìm kiếm dự án', requiresAuth: true, requiresPrivileges: ['ViewProject'] },
                                    component: () => import('@/views/master-data/projects/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_project',
                                    meta: { label: 'Thêm mới dự án', requiresAuth: true, requiresPrivileges: ['ManageProject'] },
                                    component: () => import('@/views/master-data/projects/create')
                                },
                                {
                                    path: ':projectId',
                                    redirect: '/master-data/projects/:projectId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewProject', 'ManageProject'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'project_detail_info',
                                            meta: { label: 'Xem chi tiết dự án', requiresAuth: true, requiresPrivileges: ['ViewProject', 'ManageProject'] },
                                            component: () => import('@/views/master-data/projects/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'project_edit',
                                            meta: { label: 'Sửa dự án', editing: true, requiresAuth: true, requiresPrivileges: ['ViewProject', 'ManageProject'] },
                                            component: () => import('@/views/master-data/projects/detail')
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'countries',
                            name: 'countries',
                            redirect: '/master-data/countries/list',
                            meta: { label: 'Quốc gia' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'country_list',
                                    meta: { label: 'Tra cứu, tìm kiếm quốc gia', requiresAuth: true, requiresPrivileges: ['ViewCountry'] },
                                    component: () => import('@/views/master-data/countries/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_country',
                                    meta: { label: 'Thêm mới quốc gia', requiresAuth: true, requiresPrivileges: ['ManageCountry'] },
                                    component: () => import('@/views/master-data/countries/create')
                                },
                                {
                                    path: ':countryId',
                                    redirect: '/master-data/countries/:countryId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewCountry', 'ManageCountry'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'country_detail_info',
                                            meta: { label: 'Xem chi tiết quốc gia', requiresAuth: true, requiresPrivileges: ['ViewProject', 'ManageProject'] },
                                            component: () => import('@/views/master-data/countries/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'country_edit',
                                            meta: { label: 'Sửa quốc gia', editing: true, requiresAuth: true, requiresPrivileges: ['ViewProject', 'ManageProject'] },
                                            component: () => import('@/views/master-data/countries/detail')
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'regions',
                            name: 'regions',
                            redirect: '/master-data/regions/list',
                            meta: { label: 'Địa bàn' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'region_list',
                                    meta: { label: 'Tra cứu, tìm kiếm địa bàn', requiresAuth: true, requiresPrivileges: ['ViewRegion'] },
                                    component: () => import('@/views/master-data/regions/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_region',
                                    meta: { label: 'Thêm mới địa bàn', requiresAuth: true, requiresPrivileges: ['ManageRegion'] },
                                    component: () => import('@/views/master-data/regions/create')
                                },
                                {
                                    path: ':regionId',
                                    redirect: '/master-data/regions/:regionId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewRegion', 'ManageRegion'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'region_detail_info',
                                            meta: { label: 'Xem chi tiết địa bàn', requiresAuth: true, requiresPrivileges: ['ViewRegion', 'ManageRegion'] },
                                            component: () => import('@/views/master-data/regions/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'region_edit',
                                            meta: { label: 'Sửa địa bàn', editing: true, requiresAuth: true, requiresPrivileges: ['ViewRegion', 'ManageRegion'] },
                                            component: () => import('@/views/master-data/regions/detail')
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'asset-types',
                            name: 'asset_types',
                            redirect: '/master-data/asset-types/list',
                            meta: { label: 'Nhóm tài sản' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'asset_type_list',
                                    meta: {
                                        label: 'Tra cứu, tìm kiếm nhóm tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetType']
                                    },
                                    component: () => import('@/views/master-data/asset-types/list-new')
                                },
                                {
                                    path: 'create',
                                    name: 'asset_type_create',
                                    meta: { label: 'Thêm mới nhóm tài sản', requiresAuth: true, requiresPrivileges: ['ManageAssetType'] },
                                    component: () => import('@/views/master-data/asset-types/create')
                                },
                                //{
                                //    path: ':assetTypeId',
                                //    name: 'asset_type_edit',
                                //    meta: { label: 'Sửa', requiresAuth: true, requiresPrivileges: ['ViewAssetType', 'ManageAssetType'] },
                                //    component: () => import('@/views/master-data/asset-types/edit')
                                //}
                                {
                                    path: ':assetTypeId',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewAssetType', 'ManageAssetType'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'asset_type_detail_info',
                                            meta: { label: 'Xem chi tiết nhóm tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetType', 'ManageAssetType'] },
                                            component: () => import('@/views/master-data/asset-types/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'asset_type_edit',
                                            meta: { label: 'Sửa nhóm tài sản', editing: true, requiresAuth: true, requiresPrivileges: ['ViewAssetType', 'ManageAssetType'] },
                                            component: () => import('@/views/master-data/asset-types/detail')
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'increasement-causes',
                            name: 'increasement_causes',
                            redirect: '/master-data/increasement-causes/list',
                            meta: { label: 'Lý do tăng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'increasement_cause_list',
                                    meta: { label: 'Tra cứu, tìm kiếm lý do tăng', assetMutationCauseTypeIds: [1, 2, 7], requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause'] },
                                    component: () => import('@/views/master-data/asset-mutation-causes/list')
                                },
                                {
                                    path: 'create',
                                    name: 'increasement_cause_create',
                                    meta: { label: 'Thêm mới lý do tăng', assetMutationCauseTypeIds: [1, 2, 7], requiresAuth: true, requiresPrivileges: ['ManageAssetMutationCause'] },
                                    component: () => import('@/views/master-data/asset-mutation-causes/create')
                                },
                                {
                                    path: ':assetMutationCauseId',
                                    redirect: '/master-data/increasement-causes/:assetMutationCauseId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'increasement_cause_detail_info',
                                            meta: { label: 'Xem chi tiết lý do tăng', assetMutationCauseTypeIds: [1, 2, 7], requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'] },
                                            component: () => import('@/views/master-data/asset-mutation-causes/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'increasement_cause_edit',
                                            meta: { label: 'Sửa lý do tăng', assetMutationCauseTypeIds: [1, 2, 7], editing: true, requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'] },
                                            component: () => import('@/views/master-data/asset-mutation-causes/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'decreasement-causes',
                            name: 'decreasement_causes',
                            redirect: '/master-data/decreasement-causes/list',
                            meta: { label: 'Lý do giảm' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'decreasement_cause_list',
                                    meta: { label: 'Tra cứu, tìm kiếm lý do giảm', assetMutationCauseTypeIds: [3, 5, 6], requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause'] },
                                    component: () => import('@/views/master-data/asset-mutation-causes/list')
                                },
                                {
                                    path: 'create',
                                    name: 'decreasement_cause_create',
                                    meta: { label: 'Thêm mới lý do giảm', assetMutationCauseTypeIds: [3, 5, 6], requiresAuth: true, requiresPrivileges: ['ManageAssetMutationCause'] },
                                    component: () => import('@/views/master-data/asset-mutation-causes/create')
                                },
                                {
                                    path: ':assetMutationCauseId',
                                    redirect: '/master-data/decreasement-causes/:assetMutationCauseId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'decreasement_cause_detail_info',
                                            meta: { label: 'Xem chi tiết lý do giảm', assetMutationCauseTypeIds: [3, 5, 6], requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'] },
                                            component: () => import('@/views/master-data/asset-mutation-causes/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'decreasement_cause_edit',
                                            meta: { label: 'Sửa lý do giảm', assetMutationCauseTypeIds: [3, 5, 6], editing: true, requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'] },
                                            component: () => import('@/views/master-data/asset-mutation-causes/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'asset-mutation-cause-types',
                            name: 'asset_mutation_cause_types',
                            redirect: '/master-data/asset-mutation-cause-types/list',
                            meta: { label: 'Loại lý do biến động' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'asset_mutation_cause_type_list',
                                    meta: { label: 'Tra cứu, tìm kiếm loại lý do biến động', requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCauseType'] },
                                    component: () => import('@/views/master-data/asset-mutation-cause-types/list')
                                },
                                {
                                    path: 'create',
                                    name: 'asset_mutation_cause_type_create',
                                    meta: { label: 'Thêm mới loại lý do biến động', requiresAuth: true, requiresPrivileges: ['ManageAssetMutationCauseType'] },
                                    component: () => import('@/views/master-data/asset-mutation-cause-types/create')
                                },
                                {
                                    path: ':assetMutationCauseTypeId',
                                    redirect: '/master-data/asset-mutation-cause-types/:assetMutationCauseTypeId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCauseType', 'ManageAssetMutationCauseType'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'asset_mutation_cause_type_detail_info',
                                            meta: { label: 'Xem chi tiết loại lý do biến động', requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCauseType', 'ManageAssetMutationCauseType'] },
                                            component: () => import('@/views/master-data/asset-mutation-cause-types/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'asset_mutation_cause_type_edit',
                                            meta: { label: 'Sửa loại lý do biến động', editing: true, requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCauseType', 'ManageAssetMutationCauseType'] },
                                            component: () => import('@/views/master-data/asset-mutation-cause-types/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'asset-mutation-causes',
                            name: 'asset_mutation_causes',
                            redirect: '/master-data/asset-mutation-causes/list',
                            meta: { label: 'Lý do biến động' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'asset_mutation_cause_list',
                                    meta: { label: 'Tra cứu, tìm kiếm lý do biến động', requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause'] },
                                    component: () => import('@/views/master-data/asset-mutation-causes/list')
                                },
                                {
                                    path: 'create',
                                    name: 'asset_mutation_cause_create',
                                    meta: { label: 'Thêm mới lý do biến động', requiresAuth: true, requiresPrivileges: ['ManageAssetMutationCause'] },
                                    component: () => import('@/views/master-data/asset-mutation-causes/create')
                                },
                                {
                                    path: ':assetMutationCauseId',
                                    redirect: '/master-data/asset-mutation-causes/:assetMutationCauseId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'asset_mutation_cause_detail_info',
                                            meta: { label: 'Xem chi tiết lý do biến động', requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'] },
                                            component: () => import('@/views/master-data/asset-mutation-causes/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'asset_mutation_cause_edit',
                                            meta: { label: 'Sửa lý do biến động', editing: true, requiresAuth: true, requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'] },
                                            component: () => import('@/views/master-data/asset-mutation-causes/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'asset-sources',
                            name: 'asset_sources',
                            redirect: '/master-data/asset-sources/list',
                            meta: { label: 'Nguồn hình thành tài sản' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'asset_source_list',
                                    meta: { label: 'Tra cứu, tìm kiếm nguồn hình thành tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetSource'] },
                                    component: () => import('@/views/master-data/asset-sources/list-new')
                                },
                                {
                                    path: 'create',
                                    name: 'asset_source_create',
                                    meta: { label: 'Thêm mới nguồn hình thành tài sản', requiresAuth: true, requiresPrivileges: ['ManageAssetSource'] },
                                    component: () => import('@/views/master-data/asset-sources/create')
                                },
                                //{
                                //    path: ':assetSourceId',
                                //    name: 'asset_source_edit',
                                //    meta: { label: 'Sửa', requiresAuth: true, requiresPrivileges: ['ViewAssetSource', 'ManageAssetSource'] },
                                //    component: () => import('@/views/master-data/asset-sources/edit')
                                //},
                                {
                                    path: ':assetSourceId',
                                    redirect: '/master-data/asset-sources/:assetSourceId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewAssetSource', 'ManageAssetSource'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'asset_source_detail_info',
                                            meta: { label: 'Xem chi tiết nguồn hình thành tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetSource', 'ManageAssetSource'] },
                                            component: () => import('@/views/master-data/asset-sources/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'asset_source_edit',
                                            meta: { label: 'Cập nhật nguồn hình thành tài sản', editing: true, requiresAuth: true, requiresPrivileges: ['ViewAssetSource', 'ManageAssetSource'] },
                                            component: () => import('@/views/master-data/asset-sources/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'asset-handling-forms',
                            name: 'asset_handling_forms',
                            redirect: '/master-data/asset-handling-forms/list',
                            meta: { label: 'Hình thức xử lý' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'asset_handling_forms_list',
                                    meta: { label: 'Tra cứu, tìm kiếm hình thức xử lý tài sản xác lập', requiresAuth: true, requiresPrivileges: ['ViewHandlingForm'] },
                                    component: () => import('@/views/master-data/asset-handling-forms/list')
                                },
                                {
                                    path: 'create',
                                    name: 'asset_handling_forms_create',
                                    meta: { label: 'Thêm mới hình thức xử lý tài sản xác lập', requiresAuth: true, requiresPrivileges: ['ManageHandlingForm'] },
                                    component: () => import('@/views/master-data/asset-handling-forms/create')
                                },
                                {
                                    path: ':assetHandlingFormId',
                                    redirect: '/master-data/asset-handling-forms/:assetHandlingFormId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewHandlingForm', 'ManageHandlingForm'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'asset_handling_form_detail_info',
                                            meta: { label: 'Xem chi tiết hình thức xử lý tài sản xác lập', requiresAuth: true, requiresPrivileges: ['ViewHandlingForm', 'ManageHandlingForm'] },
                                            component: () => import('@/views/master-data/asset-handling-forms/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'asset_handling_form_edit',
                                            meta: { label: 'Sửa hình thức xử lý tài sản xác lập', editing: true, requiresAuth: true, requiresPrivileges: ['ViewHandlingForm', 'ManageHandlingForm'] },
                                            component: () => import('@/views/master-data/asset-handling-forms/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'asset-handling-methods',
                            name: 'asset_handling_methods',
                            redirect: '/master-data/asset-handling-methods/list',
                            meta: { label: 'Phương thức xử lý' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'asset_handling_methods_list',
                                    meta: { label: 'Tra cứu, tìm kiếm phương thức xử lý tài sản xác lập', requiresAuth: true, requiresPrivileges: ['ViewHandlingMethod'] },
                                    component: () => import('@/views/master-data/asset-handling-methods/list')
                                },
                                {
                                    path: 'create',
                                    name: 'asset_handling_methods_create',
                                    meta: { label: 'Thêm mới phương thức xử lý tài sản xác lập', requiresAuth: true, requiresPrivileges: ['ManageHandlingMethod'] },
                                    component: () => import('@/views/master-data/asset-handling-methods/create')
                                },
                                {
                                    path: ':assetHandlingMethodId',
                                    redirect: '/master-data/asset-handling-methods/:assetHandlingMethodId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewHandlingMethod', 'ManageHandlingMethod'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'asset_handling_method_detail_info',
                                            meta: { label: 'Xem chi tiết phương thức xử lý tài sản xác lập', requiresAuth: true, requiresPrivileges: ['ViewHandlingMethod', 'ManageHandlingMethod'] },
                                            component: () => import('@/views/master-data/asset-handling-methods/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'asset_handling_method_edit',
                                            meta: { label: 'Sửa phương thức xử lý tài sản xác lập', editing: true, requiresAuth: true, requiresPrivileges: ['ViewHandlingMethod', 'ManageHandlingMethod'] },
                                            component: () => import('@/views/master-data/asset-handling-methods/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'asset-usage-states',
                            name: 'asset_usage_states',
                            redirect: '/master-data/asset-usage-states/list',
                            meta: { label: 'Hiện trạng sử dụng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'asset_usage_states_list',
                                    meta: { label: 'Tra cứu, tìm kiếm hiện trạng sử dụng', requiresAuth: true, requiresPrivileges: ['ViewUsageState'] },
                                    component: () => import('@/views/master-data/asset-usage-states/list')
                                },
                                {
                                    path: 'create',
                                    name: 'asset_usage_states_create',
                                    meta: { label: 'Thêm mới hiện trạng sử dụng', requiresAuth: true, requiresPrivileges: ['ManageUsageState'] },
                                    component: () => import('@/views/master-data/asset-usage-states/create')
                                },
                                {
                                    path: ':assetUsageStateId',
                                    redirect: '/master-data/asset-usage-states/:assetUsageStateId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewUsageState', 'ManageUsageState'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'asset_usage_states_detail_info',
                                            meta: { label: 'Xem chi tiết hiện trạng sử dụng', requiresAuth: true, requiresPrivileges: ['ViewUsageState', 'ManageUsageState'] },
                                            component: () => import('@/views/master-data/asset-usage-states/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'asset_usage_states_edit',
                                            meta: { label: 'Sửa hiện trạng sử dụng', editing: true, requiresAuth: true, requiresPrivileges: ['ViewUsageState', 'ManageUsageState'] },
                                            component: () => import('@/views/master-data/asset-usage-states/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'asset-usage-purposes',
                            name: 'asset_usage_purposes',
                            redirect: '/master-data/asset-usage-purposes/list',
                            meta: { label: 'Mục đích sử dụng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'asset_usage_purposes_list',
                                    meta: { label: 'Tra cứu, tìm kiếm mục đích sử dụng', requiresAuth: true, requiresPrivileges: ['ViewUsagePurpose'] },
                                    component: () => import('@/views/master-data/asset-usage-purposes/list')
                                },
                                {
                                    path: 'create',
                                    name: 'asset_usage_purposes_create',
                                    meta: { label: 'Thêm mới mục đích sử dụng', requiresAuth: true, requiresPrivileges: ['ManageUsagePurpose'] },
                                    component: () => import('@/views/master-data/asset-usage-purposes/create')
                                },
                                {
                                    path: ':assetUsagePurposeId',
                                    redirect: '/master-data/asset-usage-purposes/:assetUsagePurposeId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewUsagePurpose', 'ManageUsagePurpose'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'asset_usage_purpose_detail_info',
                                            meta: { label: 'Xem chi tiết mục đích sử dụng', requiresAuth: true, requiresPrivileges: ['ViewUsagePurpose', 'ManageUsagePurpose'] },
                                            component: () => import('@/views/master-data/asset-usage-purposes/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'asset_usage_purpose_edit',
                                            meta: { label: 'Sửa mục đích sử dụng', editing: true, requiresAuth: true, requiresPrivileges: ['ViewUsagePurpose', 'ManageUsagePurpose'] },
                                            component: () => import('@/views/master-data/asset-usage-purposes/detail')
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'asset-type-trees',
                            name: 'asset-type-trees',
                            redirect: '/master-data/asset-type-trees/list',
                            meta: { label: 'Cây phân loại tài sản' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'asset_type_trees_list',
                                    meta: { label: 'Tra cứu, tìm kiếm cây phân loại tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetTypeTree'] },
                                    component: () => import('@/views/master-data/asset-type-trees/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_asset_type_tree',
                                    meta: { label: 'Thêm mới cây phân loại tài sản', requiresAuth: true, requiresPrivileges: ['ManageAssetTypeTree'] },
                                    component: () => import('@/views/master-data/asset-type-trees/create')
                                },
                                {
                                    path: ':assetTypeTreeId',
                                    redirect: '/master-data/asset-type-trees/:assetTypeTreeId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewAssetTypeTree', 'ManageAssetTypeTree'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'asset_type_tree_detail_info',
                                            meta: { label: 'Xem chi tiết cây phân loại tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetTypeTree', 'ManageAssetTypeTree'] },
                                            component: () => import('@/views/master-data/asset-type-trees/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'asset_type_tree_edit',
                                            meta: { label: 'Sửa cây phân loại tài sản', editing: true, requiresAuth: true, requiresPrivileges: ['ViewAssetTypeTree', 'ManageAssetTypeTree'] },
                                            component: () => import('@/views/master-data/asset-type-trees/detail')
                                        }
                                    ]
                                }
                            ]
                        },
                    ]
                },
                {
                    path: 'data',
                    name: 'manage_data',
                    redirect: '/data/organization-assets',
                    meta: { label: 'Quản lý dữ liệu đồng bộ' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'assets',
                            name: 'assets',
                            redirect: '/data/assets/list',
                            meta: { label: 'Tài sản' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'assets_list',
                                    meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/data/assets/list')
                                },
                                {
                                    path: ':assetId',
                                    name: 'assets_detail',
                                    meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/data/assets/detail')
                                },
                                {
                                    path: 'asset-mutations',
                                    //name: 'organization_asset_mutations',
                                    redirect: '/data/assets/asset-mutations/list',
                                    meta: { label: 'Biến động' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'asset_mutations_list',
                                            meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/data/asset-mutations/list')
                                        },
                                        {
                                            path: ':assetMutationId',
                                            name: 'asset_mutations_detail',
                                            meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', requiresAuth: true, adminOnly: true },
                                            component: () => import('@/views/data/asset-mutations/detail')
                                        },
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'organization-assets',
                            name: 'organization_assets',
                            redirect: '/data/organization-assets/list',
                            meta: { label: 'Tài sản tại cơ quan, tổ chức, đơn vị' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'organization_assets_list',
                                    meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 1, syncDataSource: 1, requiresAuth: true, requiresPrivileges: ['QLTSC_ViewAsset'] },
                                    component: () => import('@/views/data/assets/list')
                                },
                                {
                                    path: ':assetId',
                                    name: 'organization_assets_detail',
                                    meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', assetTypeGroupRoot: 1, syncDataSource: 1, requiresAuth: true, requiresPrivileges: ['QLTSC_ViewAsset'] },
                                    component: () => import('@/views/data/assets/detail')
                                },
                                {
                                    path: 'asset-mutations',
                                    //name: 'organization_asset_mutations',
                                    redirect: '/data/organization-assets/asset-mutations/list',
                                    //meta: { label: 'Biến động' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'organization_asset_mutations_list',
                                            meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 1, syncDataSource: 1, requiresAuth: true, requiresPrivileges: ['QLTSC_ViewAssetMutation'] },
                                            component: () => import('@/views/data/asset-mutations/list')
                                        },
                                        {
                                            path: ':assetMutationId',
                                            name: 'organization_asset_mutations_detail',
                                            meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 1, syncDataSource: 1, requiresAuth: true, requiresPrivileges: ['QLTSC_ViewAssetMutation'] },
                                            component: () => import('@/views/data/asset-mutations/detail')
                                        },
                                    ]
                                },
                                {
                                    path: 'asset-inventories',
                                    //name: 'organization_asset_inventories',
                                    redirect: '/data/organization-assets/asset-inventories/list',
                                    //meta: { label: 'Kiểm kê tài sản' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'organization_asset_inventories_list',
                                            meta: { label: 'Tra cứu danh sách kiểm kê tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetInventory'] },
                                            component: () => import('@/views/data/asset-inventories/list')
                                        },
                                        {
                                            path: ':assetInventoryId',
                                            name: 'organization_asset_inventories_detail',
                                            meta: { label: 'Xem chi tiết kiểm kê tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetInventory'] },
                                            component: () => import('@/views/data/asset-inventories/detail')
                                        },
                                    ]
                                },
                                {
                                    path: 'asset-exploitation-decisions',
                                    //name: 'organization_asset_exploitation_decisions',
                                    redirect: '/data/organization-assets/asset-exploitation-decisions/list',
                                    //meta: { label: 'Quyết định khai thác tài sản' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'organization_asset_exploitation_decisions_list',
                                            meta: { label: 'Tra cứu danh sách khai thác tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetExploitationDecision', 'ManageAssetExploitationDecision', 'ViewAssetExploitationDocument', 'ManageAssetExploitationDocument'] },
                                            component: () => import('@/views/data/asset-exploitation-decisions/list')
                                        },
                                        {
                                            path: ':assetExploitationDecisionId',
                                            name: 'organization_asset_exploitation_decisions_detail',
                                            meta: { label: 'Xem chi tiết khai thác tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetExploitationDecision', 'ManageAssetExploitationDecision', 'ViewAssetExploitationDocument', 'ManageAssetExploitationDocument'] },
                                            component: () => import('@/views/data/asset-exploitation-decisions/detail')
                                        },
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'infrastructure-assets',
                            name: 'infrastructure_assets',
                            redirect: '/data/infrastructure-assets/ctns',
                            meta: { label: 'Tài sản kết cầu hạ tầng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'ctns',
                                    name: 'ctns',
                                    redirect: '/data/infrastructure-assets/ctns/list',
                                    meta: { label: 'Công trình nước sạch' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'infrastructure_assets_ctns_list',
                                            meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 21, syncDataSource: 4, requiresAuth: true, requiresPrivileges: ['CTNS_ViewAsset'] },
                                            component: () => import('@/views/data/assets/list')
                                        },
                                        {
                                            path: ':assetId',
                                            name: 'infrastructure_assets_ctns_detail',
                                            meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', assetTypeGroupRoot: 21, syncDataSource: 4, requiresAuth: true, requiresPrivileges: ['CTNS_ViewAsset'] },
                                            component: () => import('@/views/data/assets/detail')
                                        },
                                        {
                                            path: 'asset-mutations',
                                            //name: 'infrastructure_asset_mutations',
                                            redirect: '/data/infrastructure-assets/asset-mutations/list',
                                            //meta: { label: 'Biến động' },
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: 'list',
                                                    name: 'infrastructure_asset_mutations_ctns_list',
                                                    meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 21, syncDataSource: 4, requiresAuth: true, requiresPrivileges: ['CTNS_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/list')
                                                },
                                                {
                                                    path: ':assetMutationId',
                                                    name: 'infrastructure_asset_mutations_ctns_detail',
                                                    meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 21, syncDataSource: 4, requiresAuth: true, requiresPrivileges: ['CTNS_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/detail')
                                                },
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'htgtdb',
                                    name: 'htgtdb',
                                    redirect: '/data/infrastructure-assets/htgtdb/list',
                                    meta: { label: 'Hạ tầng giao thông đường bộ' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'infrastructure_assets_htgtdb_list',
                                            meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 22, syncDataSource: 3, requiresAuth: true, requiresPrivileges: ['HTGTDB_ViewAsset'] },
                                            component: () => import('@/views/data/assets/list')
                                        },
                                        {
                                            path: ':assetId',
                                            name: 'infrastructure_assets_htgtdb_detail',
                                            meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', assetTypeGroupRoot: 22, syncDataSource: 3, requiresAuth: true, requiresPrivileges: ['HTGTDB_ViewAsset'] },
                                            component: () => import('@/views/data/assets/detail')
                                        },
                                        {
                                            path: 'asset-mutations',
                                            //name: 'infrastructure_asset_mutations',
                                            redirect: '/data/infrastructure-assets/asset-mutations/list',
                                            //meta: { label: 'Biến động' },
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: 'list',
                                                    name: 'infrastructure_asset_mutations_htgtdb_list',
                                                    meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 22, syncDataSource: 3, requiresAuth: true, requiresPrivileges: ['HTGTDB_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/list')
                                                },
                                                {
                                                    path: ':assetMutationId',
                                                    name: 'infrastructure_asset_mutations_htgtdb_detail',
                                                    meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 22, syncDataSource: 3, requiresAuth: true, requiresPrivileges: ['HTGTDB_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/detail')
                                                },
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'kchtds',
                                    name: 'kchtds',
                                    redirect: '/data/infrastructure-assets/kchtds/list',
                                    meta: { label: 'KCHT đường sắt' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'infrastructure_assets_kchtds_list',
                                            meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 23, syncDataSource: 5, requiresAuth: true, requiresPrivileges: ['KCHTDS_ViewAsset'] },
                                            component: () => import('@/views/data/assets/list')
                                        },
                                        {
                                            path: ':assetId',
                                            name: 'infrastructure_assets_kchtds_detail',
                                            meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 23, syncDataSource: 5, requiresAuth: true, requiresPrivileges: ['KCHTDS_ViewAsset'] },
                                            component: () => import('@/views/data/assets/detail')
                                        },
                                        {
                                            path: 'asset-mutations',
                                            //name: 'infrastructure_asset_mutations',
                                            redirect: '/data/infrastructure-assets/asset-mutations/list',
                                            //meta: { label: 'Biến động' },
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: 'list',
                                                    name: 'infrastructure_asset_mutations_kchtds_list',
                                                    meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 23, syncDataSource: 5, requiresAuth: true, requiresPrivileges: ['KCHTDS_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/list')
                                                },
                                                {
                                                    path: ':assetMutationId',
                                                    name: 'infrastructure_asset_mutations_kchtds_detail',
                                                    meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 23, syncDataSource: 5, requiresAuth: true, requiresPrivileges: ['KCHTDS_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/detail')
                                                },
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'kchttl',
                                    name: 'kchttl',
                                    redirect: '/data/infrastructure-assets/kchttl/list',
                                    meta: { label: 'KCHT thủy lợi' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'infrastructure_assets_kchttl_list',
                                            meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 24, syncDataSource: 6, requiresAuth: true, requiresPrivileges: ['KCHTTL_ViewAsset'] },
                                            component: () => import('@/views/data/assets/list')
                                        },
                                        {
                                            path: ':assetId',
                                            name: 'infrastructure_assets_kchttl_detail',
                                            meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', assetTypeGroupRoot: 24, syncDataSource: 6, requiresAuth: true, requiresPrivileges: ['KCHTTL_ViewAsset'] },
                                            component: () => import('@/views/data/assets/detail')
                                        },
                                        {
                                            path: 'asset-mutations',
                                            //name: 'infrastructure_asset_mutations',
                                            redirect: '/data/infrastructure-assets/asset-mutations/list',
                                            //meta: { label: 'Biến động' },
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: 'list',
                                                    name: 'infrastructure_asset_mutations_kchttl_list',
                                                    meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 24, syncDataSource: 6, requiresAuth: true, requiresPrivileges: ['KCHTTL_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/list')
                                                },
                                                {
                                                    path: ':assetMutationId',
                                                    name: 'infrastructure_asset_mutations_kchttl_detail',
                                                    meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 24, syncDataSource: 6, requiresAuth: true, requiresPrivileges: ['KCHTTL_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/detail')
                                                },
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'kchthk',
                                    name: 'kchthk',
                                    redirect: '/data/infrastructure-assets/kchthk/list',
                                    meta: { label: 'KCHT hàng không' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'infrastructure_assets_kchthk_list',
                                            meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 25, syncDataSource: 7, requiresAuth: true, requiresPrivileges: ['KCHTHK_ViewAsset'] },
                                            component: () => import('@/views/data/assets/list')
                                        },
                                        {
                                            path: ':assetId',
                                            name: 'infrastructure_assets_kchthk_detail',
                                            meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', assetTypeGroupRoot: 25, syncDataSource: 7, requiresAuth: true, requiresPrivileges: ['KCHTHK_ViewAsset'] },
                                            component: () => import('@/views/data/assets/detail')
                                        },
                                        {
                                            path: 'asset-mutations',
                                            //name: 'infrastructure_asset_mutations',
                                            redirect: '/data/infrastructure-assets/asset-mutations/list',
                                            //meta: { label: 'Biến động' },
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: 'list',
                                                    name: 'infrastructure_asset_mutations_kchthk_list',
                                                    meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 25, syncDataSource: 7, requiresAuth: true, requiresPrivileges: ['KCHTHK_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/list')
                                                },
                                                {
                                                    path: ':assetMutationId',
                                                    name: 'infrastructure_asset_mutations_kchthk_detail',
                                                    meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 25, syncDataSource: 7, requiresAuth: true, requiresPrivileges: ['KCHTHK_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/detail')
                                                },
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'kchthh',
                                    name: 'kchthh',
                                    redirect: '/data/infrastructure-assets/kchthh/list',
                                    meta: { label: 'KCHT hàng hải' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'infrastructure_assets_kchthh_list',
                                            meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 26, syncDataSource: 8, requiresAuth: true, requiresPrivileges: ['KCHTHH_ViewAsset'] },
                                            component: () => import('@/views/data/assets/list')
                                        },
                                        {
                                            path: ':assetId',
                                            name: 'infrastructure_assets_kchthh_detail',
                                            meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', assetTypeGroupRoot: 26, syncDataSource: 8, requiresAuth: true, requiresPrivileges: ['KCHTHH_ViewAsset'] },
                                            component: () => import('@/views/data/assets/detail')
                                        },
                                        {
                                            path: 'asset-mutations',
                                            //name: 'infrastructure_asset_mutations',
                                            redirect: '/data/infrastructure-assets/asset-mutations/list',
                                            //meta: { label: 'Biến động' },
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: 'list',
                                                    name: 'infrastructure_asset_mutations_kchthh_list',
                                                    meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 26, syncDataSource: 8, requiresAuth: true, requiresPrivileges: ['KCHTHH_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/list')
                                                },
                                                {
                                                    path: ':assetMutationId',
                                                    name: 'infrastructure_asset_mutations_kchthh_detail',
                                                    meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 26, syncDataSource: 8, requiresAuth: true, requiresPrivileges: ['KCHTHH_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/detail')
                                                },
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'kchtgtdtnd',
                                    name: 'kchtgtdtnd',
                                    redirect: '/data/infrastructure-assets/kchtgtdtnd/list',
                                    meta: { label: 'KCHT giao thông đường thủy nội địa' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'infrastructure_assets_kchtgtdtnd_list',
                                            meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 27, syncDataSource: 9, requiresAuth: true, requiresPrivileges: ['KCHTGTDTND_ViewAsset'] },
                                            component: () => import('@/views/data/assets/list')
                                        },
                                        {
                                            path: ':assetId',
                                            name: 'infrastructure_assets_kchtgtdtnd_detail',
                                            meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', assetTypeGroupRoot: 27, syncDataSource: 9, requiresAuth: true, requiresPrivileges: ['KCHTGTDTND_ViewAsset'] },
                                            component: () => import('@/views/data/assets/detail')
                                        },
                                        {
                                            path: 'asset-mutations',
                                            //name: 'infrastructure_asset_mutations',
                                            redirect: '/data/infrastructure-assets/asset-mutations/list',
                                            //meta: { label: 'Biến động' },
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: 'list',
                                                    name: 'infrastructure_asset_mutations_kchtgtdtnd_list',
                                                    meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 27, syncDataSource: 9, requiresAuth: true, requiresPrivileges: ['KCHTGTDTND_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/list')
                                                },
                                                {
                                                    path: ':assetMutationId',
                                                    name: 'infrastructure_asset_mutations_kchtgtdtnd_detail',
                                                    meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 27, syncDataSource: 9, requiresAuth: true, requiresPrivileges: ['KCHTGTDTND_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/detail')
                                                },
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'kchtk',
                                    name: 'kchtk',
                                    redirect: '/data/infrastructure-assets/kchtk/list',
                                    meta: { label: 'KCHT khác' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'infrastructure_assets_kchtk_list',
                                            meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 28, syncDataSource: 10, requiresAuth: true, requiresPrivileges: ['KCHTK_ViewAsset'] },
                                            component: () => import('@/views/data/assets/list')
                                        },
                                        {
                                            path: ':assetId',
                                            name: 'infrastructure_assets_kchtk_detail',
                                            meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', assetTypeGroupRoot: 28, syncDataSource: 10, requiresAuth: true, requiresPrivileges: ['KCHTK_ViewAsset'] },
                                            component: () => import('@/views/data/assets/detail')
                                        },
                                        {
                                            path: 'asset-mutations',
                                            //name: 'infrastructure_asset_mutations',
                                            redirect: '/data/infrastructure-assets/asset-mutations/list',
                                            //meta: { label: 'Biến động' },
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: 'list',
                                                    name: 'infrastructure_asset_mutations_kchtk_list',
                                                    meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 28, syncDataSource: 10, requiresAuth: true, requiresPrivileges: ['KCHTK_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/list')
                                                },
                                                {
                                                    path: ':assetMutationId',
                                                    name: 'infrastructure_asset_mutations_kchtk_detail',
                                                    meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 28, syncDataSource: 10, requiresAuth: true, requiresPrivileges: ['KCHTK_ViewAssetMutation'] },
                                                    component: () => import('@/views/data/asset-mutations/detail')
                                                },
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },

                        {
                            path: 'national-public-assets',
                            name: 'national-public-assets',
                            redirect: '/data/national-public-assets/list',
                            meta: { label: 'Tài sản xác lập sở hữu toàn dân' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'confiscate-decisions',
                                    redirect: '/data/national-public-assets/confiscate-decisions/list',
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'national_public_asset_confiscate_decisions_list',
                                            meta: { label: 'Tra cứu danh sách quyết định tịch thu/ xác lập đã gửi lên CSDLQG', requiresAuth: true, requiresPrivileges: ['ViewNationalPublicAsset'] },
                                            component: () => import('@/views/data/national-public-asset-confiscate-decisions/list'),
                                        },
                                        {
                                            path: ':confiscateDecisionId',
                                            name: 'national_public_asset_confiscate_decisions_detail',
                                            meta: { label: 'Xem chi tiết quyết định tịch thu/ xác lập đã gửi lên', requiresAuth: true, requiresPrivileges: ['ViewNationalPublicAsset'] },
                                            component: () => import('@/views/data/national-public-asset-confiscate-decisions/detail')
                                        },
                                    ]
                                },
                                {
                                    path: 'handling-decision-results',
                                    redirect: '/data/national-public-assets/handling-decision-results/list',
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'national_public_asset_handling_decisions_list',
                                            meta: { label: 'Tra cứu danh sách kết quả xử lý đã gửi lên CSDLQG', requiresAuth: true, requiresPrivileges: ['ViewNationalPublicAssetHandling'] },
                                            component: () => import('@/views/data/national-public-asset-handling-decision-results/list'),
                                        },
                                        {
                                            path: ':handlingDecisionId',
                                            name: 'national_public_asset_handling_decisions_detail',
                                            meta: { label: 'Xem chi tiết kết quả xử lý đã gửi lên', requiresAuth: true, requiresPrivileges: ['ViewNationalPublicAssetHandling'] },
                                            component: () => import('@/views/data/national-public-asset-handling-decision-results/detail')
                                        },
                                    ]
                                },
                                {
                                    path: 'handling-decision-accountings',
                                    redirect: '/data/national-public-assets/handling-decision-accountings/list',
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'national_public_asset_handling_decision_accountings_list',
                                            meta: { label: 'Tra cứu danh sách quản lý thu chi đã gửi lên CSDLQG', requiresAuth: true, requiresPrivileges: ['ViewNationalPublicAssetHandling'] },
                                            component: () => import('@/views/data/national-public-asset-handling-decision-accountings/list'),
                                        },
                                        {
                                            path: ':accountingId',
                                            name: 'national_public_asset_handling_decision_accountings_detail',
                                            meta: { label: 'Xem chi tiết quản lý thu chi đã gửi lên', requiresAuth: true, requiresPrivileges: ['ViewNationalPublicAsset'] },
                                            component: () => import('@/views/data/national-public-asset-handling-decision-accountings/detail')
                                        },
                                    ]
                                },
                                {
                                    path: 'list',
                                    name: 'national_public_assets_list',
                                    meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', requiresAuth: true, requiresPrivileges: ['ViewNationalPublicAsset'] },
                                    component: () => import('@/views/data/national-public-assets/list')
                                },
                                {
                                    path: ':assetId',
                                    name: 'national_public_assets_detail',
                                    meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', requiresAuth: true, requiresPrivileges: ['ViewNationalPublicAsset'] },
                                    component: () => import('@/views/data/national-public-assets/detail')
                                },
                                {
                                    path: 'asset-handlings',
                                    redirect: '/data/national-public-assets/asset-handlings/list',
                                    meta: { label: 'Phương án xử lý' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'national_public_asset_handlings_list',
                                            meta: { label: 'Tra cứu danh sách phương án xử lý đã gửi lên CSDLQG', requiresAuth: true, requiresPrivileges: ['ViewNationalPublicAssetHandling'] },
                                            component: () => import('@/views/data/national-public-asset-handlings/list')

                                        },
                                        {
                                            path: ':assetHandlingId',
                                            name: 'national_public_asset_handlings_detail',
                                            meta: { label: 'Xem chi tiết phương án xử lý đã gửi lên', requiresAuth: true, requiresPrivileges: ['ViewNationalPublicAssetHandling'] },
                                            component: () => import('@/views/data/national-public-asset-handlings/detail')
                                        },
                                    ]
                                }
                            ]
                        },



                        {
                            path: 'land-assets',
                            name: 'land_assets',
                            redirect: '/data/land-assets/list',
                            meta: { label: 'Đất đai' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'land_assets_list',
                                    meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 7, syncDataSource: 11, requiresAuth: true, requiresPrivileges: ['DATDAI_ViewAsset'] },
                                    component: () => import('@/views/data/assets/list')
                                },
                                {
                                    path: ':assetId',
                                    name: 'land_assets_detail',
                                    meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', assetTypeGroupRoot: 7, syncDataSource: 11, requiresAuth: true, requiresPrivileges: ['DATDAI_ViewAsset'] },
                                    component: () => import('@/views/data/assets/detail')
                                },
                                {
                                    path: 'asset-mutations',
                                    //name: 'organization_asset_mutations',
                                    redirect: '/data/land-assets/asset-mutations/list',
                                    //meta: { label: 'Biến động' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'land_asset_mutations_list',
                                            meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 7, syncDataSource: 11, requiresAuth: true, requiresPrivileges: ['DATDAI_ViewAssetMutation'] },
                                            component: () => import('@/views/data/asset-mutations/list')
                                        },
                                        {
                                            path: ':assetMutationId',
                                            name: 'land_asset_mutations_detail',
                                            meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 7, syncDataSource: 11, requiresAuth: true, requiresPrivileges: ['DATDAI_ViewAssetMutation'] },
                                            component: () => import('@/views/data/asset-mutations/detail')
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'resource-assets',
                            name: 'resource_assets',
                            redirect: '/data/resource-assets/list',
                            meta: { label: 'Tài nguyên' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'resource_assets_list',
                                    meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 5, syncDataSource: 12, requiresAuth: true, requiresPrivileges: ['TAINGUYEN_ViewAsset'] },
                                    component: () => import('@/views/data/assets/list')
                                },
                                {
                                    path: ':assetId',
                                    name: 'resource_assets_detail',
                                    meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', assetTypeGroupRoot: 5, syncDataSource: 12, requiresAuth: true, requiresPrivileges: ['TAINGUYEN_ViewAsset'] },
                                    component: () => import('@/views/data/assets/detail')
                                },
                                {
                                    path: 'asset-mutations',
                                    //name: 'organization_asset_mutations',
                                    redirect: '/data/resource-assets/asset-mutations/list',
                                    //meta: { label: 'Biến động' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'resource_asset_mutations_list',
                                            meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 5, syncDataSource: 12, requiresAuth: true, requiresPrivileges: ['TAINGUYEN_ViewAssetMutation'] },
                                            component: () => import('@/views/data/asset-mutations/list')
                                        },
                                        {
                                            path: ':assetMutationId',
                                            name: 'resource_asset_mutations_detail',
                                            meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 5, syncDataSource: 12, requiresAuth: true, requiresPrivileges: ['TAINGUYEN_ViewAssetMutation'] },
                                            component: () => import('@/views/data/asset-mutations/detail')
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'public-enterprise-assets',
                            name: 'public_enterprise_assets',
                            redirect: '/data/public-enterprise-assets/list',
                            meta: { label: 'Tài sản công tại doanh nghiệp' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'public_enterprise_assets_list',
                                    meta: { label: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', title: 'Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG', assetTypeGroupRoot: 6, syncDataSource: 13, requiresAuth: true, requiresPrivileges: ['TSCTDN_ViewAsset'] },
                                    component: () => import('@/views/data/assets/list')
                                },
                                {
                                    path: ':assetId',
                                    name: 'public_enterprise_assets_detail',
                                    meta: { label: 'Xem chi tiết thông tin tài sản đã gửi lên', assetTypeGroupRoot: 6, syncDataSource: 13, requiresAuth: true, requiresPrivileges: ['TSCTDN_ViewAsset'] },
                                    component: () => import('@/views/data/assets/detail')
                                },
                                {
                                    path: 'asset-mutations',
                                    //name: 'organization_asset_mutations',
                                    redirect: '/data/public-enterprise-assets/asset-mutations/list',
                                    //meta: { label: 'Biến động' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'public_enterprise_asset_mutations_list',
                                            meta: { label: 'Tra cứu danh sách biến động thông tin tài sản', title: 'Tra cứu danh sách biến động thông tin tài sản', assetTypeGroupRoot: 6, syncDataSource: 13, requiresAuth: true, requiresPrivileges: ['TSCTDN_ViewAssetMutation'] },
                                            component: () => import('@/views/data/asset-mutations/list')
                                        },
                                        {
                                            path: ':assetMutationId',
                                            name: 'public_enterprise_asset_mutations_detail',
                                            meta: { label: 'Xem chi tiết biến động thay đổi thông tin tài sản', assetTypeGroupRoot: 6, syncDataSource: 13, requiresAuth: true, requiresPrivileges: ['TSCTDN_ViewAssetMutation'] },
                                            component: () => import('@/views/data/asset-mutations/detail')
                                        },
                                    ]
                                },
                            ]
                        },

                        {
                            path: 'reports',
                            name: 'reports',
                            redirect: '/data/reports/list',
                            meta: { label: 'Báo cáo' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'reports_list',
                                    meta: {
                                        label: 'Tra cứu danh sách báo cáo đơn vị đã gửi lên CSDLQG', requiresAuth: true, requiresPrivileges: ['ViewReport']
                                    },
                                    component: () => import('@/views/data/reports/list')
                                },
                                {
                                    path: 'stats',
                                    name: 'reports_stats',
                                    meta: { label: 'Tra cứu danh sách thống kê báo cáo đồng bộ', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/data/reports/stats')
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'view-reports',
                    name: 'reporting',
                    redirect: '/view-reports/summary',
                    meta: { label: 'Báo cáo' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'summary',
                            name: 'summary_reports',
                            redirect: 'summary/list',
                            meta: { label: 'Báo cáo tổng hợp' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'summary_reports_list',
                                    meta: {
                                        label: 'Danh sách báo cáo tổng hợp', requiresAuth: true
                                        , requiresPrivileges: getViewReportRequiredPrivileges(0)
                                        , infoTypes: store.state.common.listGroupReportTypes[0].reportTypeIds, pathReportType: 'summary'
                                    },
                                    component: () => import('@/views/reports/list')
                                },
                                {
                                    path: ':reportTypeId',
                                    name: 'summary_reports_detail',
                                    meta: {
                                        label: 'Xuất báo cáo tổng hợp', requiresAuth: true
                                        , pathReportType: 'summary'
                                    },
                                    component: () => import('@/views/reports/detail')
                                },]
                        },
                        {
                            path: 'public',
                            name: 'public_reports',
                            redirect: 'public/list',
                            meta: { label: 'Báo cáo công khai' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'public_reports_list',
                                    meta: {
                                        label: 'Danh sách báo cáo công khai', requiresAuth: true
                                        , requiresPrivileges: getViewReportRequiredPrivileges(1)
                                        , infoTypes: store.state.common.listGroupReportTypes[1].reportTypeIds,
                                        pathReportType: 'public'
                                    },
                                    component: () => import('@/views/reports/list')
                                },
                                {
                                    path: ':reportTypeId',
                                    name: 'public_reports_detail',
                                    meta: {
                                        label: 'Xuất báo cáo công khai', requiresAuth: true
                                        , pathReportType: 'public'
                                    },
                                    component: () => import('@/views/reports/detail')
                                }
                            ]
                        },
                        {
                            path: 'goverment',
                            name: 'goverment',
                            redirect: 'goverment/list',
                            meta: { label: 'Báo cáo chính phủ' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'goverment_reports_list',
                                    meta: {
                                        label: 'Danh sách báo cáo chính phủ', requiresAuth: true
                                        , requiresPrivileges: getViewReportRequiredPrivileges(2)
                                        , infoTypes: store.state.common.listGroupReportTypes[2].reportTypeIds, pathReportType: 'goverment'
                                    },
                                    component: () => import('@/views/reports/list')
                                },
                                {
                                    path: ':reportTypeId',
                                    name: 'goverment_reports_detail',
                                    meta: {
                                        label: 'Xuất báo cáo chính phủ', requiresAuth: true
                                        , pathReportType: 'goverment'
                                    },
                                    component: () => import('@/views/reports/detail')
                                },
                            ]
                        },
                        {
                            path: 'national-asset-type',
                            name: 'national-asset-type-reports',
                            redirect: 'national-asset-type/list',
                            meta: { label: 'Báo cáo tài sản tịch thu/ xác lập' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'national_asset_type_reports_list',
                                    meta: {
                                        label: 'Danh sách báo cáo tài sản tịch thu/ xác lập', requiresAuth: true
                                        , requiresPrivileges: getViewReportRequiredPrivileges(4)
                                        , infoTypes: store.state.common.listGroupReportTypes[4].reportTypeIds, pathReportType: 'national-asset-type'
                                    },
                                    component: () => import('@/views/reports/list')
                                },
                                {
                                    path: ':reportTypeId',
                                    name: 'national_asset_type_reports_detail',
                                    meta: {
                                        label: 'Xuất báo cáo tài sản tịch thu/ xác lập', requiresAuth: true
                                        , pathReportType: 'national-asset-type'
                                    },
                                    component: () => import('@/views/reports/detail')
                                }
                            ]
                        },
                        {
                            path: 'other',
                            name: 'other-reports',
                            redirect: 'other/list',
                            meta: { label: 'Báo cáo khác' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'other_reports_list',
                                    meta: {
                                        label: 'Danh sách báo cáo khác', requiresAuth: true
                                        , requiresPrivileges: getViewReportRequiredPrivileges(3)
                                        , infoTypes: store.state.common.listGroupReportTypes[3].reportTypeIds, pathReportType: 'other'
                                    },
                                    component: () => import('@/views/reports/list')
                                },
                                {
                                    path: ':reportTypeId',
                                    name: 'statistic_reports_detail',
                                    meta: {
                                        label: 'Xuất báo cáo khác', requiresAuth: true
                                        , pathReportType: 'other'
                                    },
                                    component: () => import('@/views/reports/detail')
                                },
                            ]
                        },
                        {
                            path: 'lookup',
                            name: 'lookup-reports',
                            redirect: 'lookup/list',
                            meta: { label: 'Báo cáo tra cứu' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'lookup_reports_list',
                                    meta: { label: 'Danh sách', requiresAuth: true, requiresPrivileges: ['ViewLookupReport'] },
                                    component: () => import('@/views/reports/lookup/list')
                                },
                                {
                                    path: 'BCTC_01',
                                    name: 'lookup_reports_01_detail',
                                    meta: { label: 'Báo cáo tổng hợp tình hình quản lý, sử dụng tài sản công', reportCode: 'BCTC_01', title: 'Báo cáo tổng hợp tình hình quản lý, sử dụng tài sản công', periodType: 1, requiresAuth: true },
                                    component: () => import('@/views/reports/lookup/BCTC')
                                },
                                {
                                    path: 'BCTC_02',
                                    name: 'lookup_reports_02_detail',
                                    meta: { label: 'Báo cáo tổng hợp tình hình tăng, giảm tài sản công', reportCode: 'BCTC_02', title: 'Báo cáo tổng hợp tình hình tăng, giảm tài sản công', periodType: 2, increasementCauseTypeId: [1, 7], decreasementCauseTypeId: [5], requiresAuth: true },
                                    component: () => import('@/views/reports/lookup/BCTC')
                                },
                                {
                                    path: 'BCTC_03',
                                    name: 'lookup_reports_03_detail',
                                    meta: { label: 'Báo cáo tổng hợp tình hình tăng tài sản công', reportCode: 'BCTC_03', title: 'Báo cáo tổng hợp tình hình tăng tài sản công', periodType: 2, increasementCauseTypeId: [1, 7], requiresAuth: true },
                                    component: () => import('@/views/reports/lookup/BCTC')
                                },
                                {
                                    path: 'BCTC_04',
                                    name: 'lookup_reports_04_detail',
                                    meta: { label: 'Báo cáo tổng hợp tình hình giảm tài sản công', reportCode: 'BCTC_04', title: 'Báo cáo tổng hợp tình hình giảm tài sản công', periodType: 2, decreasementCauseTypeId: [5], requiresAuth: true },
                                    component: () => import('@/views/reports/lookup/BCTC')
                                }
                            ]
                        },
                        {
                            path: 'BCDC',
                            name: 'lookup_reports_01_auto_detail',
                            meta: { label: 'Báo cáo đối chiếu dữ liệu', reportCode: 'BCDC', title: 'Báo cáo đối chiếu dữ liệu', periodType: 1, requiresPrivileges: ['ViewCompareReport'], requiresAuth: true },
                            component: () => import('@/views/reports/lookup/BCDC')
                        }
                    ]
                },
                {
                    path: 'logs',
                    name: 'logs',
                    redirect: '/logs/action',
                    meta: { label: 'Nhật ký hệ thống' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'action',
                            name: 'action_logs',
                            redirect: '/logs/action/list',
                            meta: { label: 'Nhật ký người sử dụng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'action_logs_list',
                                    meta: {
                                        label: 'Tra cứu các hoạt động thao tác dữ liệu trên hệ thống', requiresAuth: true, requiresPrivileges: ['ViewActionLog']
                                    },
                                    component: () => import('@/views/logs/action/list'),
                                },
                            ]
                        },
                        {
                            path: 'sync',
                            name: 'sync_logs',
                            redirect: '/logs/sync/assets',
                            meta: { label: 'Nhật ký đồng bộ' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'assets',
                                    name: 'asset_sync_logs',
                                    redirect: '/logs/sync/assets/list',
                                    meta: { label: 'Nhật ký đồng bộ tài sản', requiresAuth: true },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                        path: 'list',
                                        name: 'asset_sync_logs_list',
                                        meta: {
                                            label: 'Tra cứu nhật ký đồng bộ tài sản',
                                            gridName: 'Danh sách nhật ký đồng bộ tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetSyncLog'], infoTypes: [1]
                                        },
                                        component: () => import('@/views/logs/sync/assets/list')
                                    },
                                    {
                                        path: ':logId',
                                        name: 'asset_sync_logs_detail',
                                        meta: { label: 'Xem chi tiết dữ liệu tài sản đã đồng bộ', requiresAuth: true, requiresPrivileges: ['ViewAssetSyncLog'], title: 'Xem chi tiết dữ liệu tài sản đã đồng bộ' },
                                        component: () => import('@/views/logs/sync/assets/detail')
                                    }
                                    ]
                                },
                                {
                                    path: 'assets-info',
                                    name: 'asset_info_sync_logs',
                                    redirect: '/logs/sync/assets-info/list',
                                    meta: { label: 'Nhật ký đồng bộ biến động thông tin tài sản', requiresAuth: true },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                        path: 'list',
                                        name: 'asset_info_sync_logs_list',
                                        meta: { label: 'Tra cứu nhật ký đồng bộ biến động thông tin trên tài sản', requiresAuth: true, requiresPrivileges: ['ViewAssetSyncLog'], title: 'Tra cứu nhật ký đồng bộ biến động thông tin trên tài sản', gridName: 'Danh sách nhật ký đồng bộ biến động thông tin trên tài sản' },
                                        component: () => import('@/views/logs/sync/assets/list')
                                    },
                                    {
                                        path: ':logId',
                                        name: 'asset_info_sync_logs_detail',
                                        meta: { label: 'Xem chi tiết dữ liệu biến động thông tin trên tài sản đã đồng bộ', requiresAuth: true, requiresPrivileges: ['ViewAssetSyncLog'], title: 'Xem chi tiết dữ liệu biến động thông tin trên tài sản đã đồng bộ' },
                                        component: () => import('@/views/logs/sync/assets/detail')
                                    }
                                    ]
                                },
                                {
                                    path: 'masterdata',
                                    name: 'master_data_sync_logs',
                                    redirect: '/logs/sync/masterdata/list',
                                    meta: { label: 'Nhật ký đồng bộ danh mục', requiresAuth: true },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'master_data_sync_logs_list',
                                            meta: { label: 'Tra cứu, tìm kiếm nhật ký đồng bộ danh mục', requiresAuth: true, requiresPrivileges: ['ViewActionLog'] },
                                            component: () => import('@/views/logs/sync/master-data/list')
                                        },
                                        {
                                            path: ':logId',
                                            name: 'master_data_sync_logs_detail',
                                            meta: { label: 'Xem chi tiết nhật ký đồng bộ danh mục', requiresAuth: true, requiresPrivileges: ['ViewActionLog'] },
                                            component: () => import('@/views/logs/sync/master-data/detail')
                                        }
                                    ]
                                },
                                {
                                    path: 'reports',
                                    name: 'report_sync_logs',
                                    redirect: '/logs/sync/reports/list',
                                    meta: { label: 'Nhật ký đồng bộ báo cáo', requiresAuth: true },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [{
                                        path: 'list',
                                        name: 'report_sync_logs_list',
                                        meta: { label: 'Tra cứu, tìm kiếm nhật ký đồng bộ Báo cáo', requiresAuth: true, requiresPrivileges: ['ViewReportSyncLog'] },
                                        component: () => import('@/views/logs/sync/reports/list')
                                    },
                                    {
                                        path: ':logId',
                                        name: 'report_sync_logs_detail',
                                        meta: { label: 'Xem chi tiết dữ liệu báo cáo đã đồng bộ', title: 'Xem chi tiết dữ liệu báo cáo đã đồng bộ', requiresAuth: true, requiresPrivileges: ['ViewReportSyncLog'] },
                                        component: () => import('@/views/logs/sync/reports/detail')
                                    }]
                                }]
                        },
                        {
                            path: 'services',
                            name: 'services_logs',
                            redirect: '/logs/services/list',
                            meta: { label: 'Nhật ký đồng bộ dữ liệu sang QLTSC', requiresAuth: true },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'services_logs_list',
                                    meta: { label: 'Tìm kiếm, tra cứu thông tin nhật ký đồng bộ dữ liệu sang QLTSC', requiresAuth: true, requiresPrivileges: ['ViewReportSyncLog'] },
                                    component: () => import('@/views/logs/services/list')
                                }

                            ]
                        },
                        {
                            path: 'elastic-logs',
                            name: 'elastic_logs',
                            redirect: '/logs/elastic/list',
                            meta: { label: 'Nhật ký đồng bộ dữ liệu trên Elastic Search', requiresAuth: true },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'elastic_logs_list',
                                    meta: { label: 'Tìm kiếm, tra cứu thông tin nhật ký đồng bộ dữ liệu trên Elastic Search', requiresAuth: true, requiresPrivileges: ['ViewReportSyncLog'] },
                                    component: () => import('@/views/logs/sync/elastic/list')
                                }

                            ]
                        },
                        {
                            path: 'backup',
                            name: 'backup_logs',
                            redirect: '/logs/backup/list',
                            meta: { label: 'Nhật ký sao lưu dữ liệu', requiresAuth: true, requiresPrivileges: ['ViewBackupLog'] },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'backup_logs_list',
                                    meta: { label: 'Tra cứu, tìm kiếm nhật ký sao lưu dữ liệu', requiresAuth: true, requiresPrivileges: ['ViewBackupLog'] },
                                    component: () => import('@/views/logs/backup/list')
                                },
                                {
                                    path: ':backupLogId',
                                    name: 'backup_logs_detail',
                                    meta: { label: 'Xem chi tiết nhật ký sao lưu dữ liệu', requiresAuth: true, requiresPrivileges: ['ViewBackupLog'] },
                                    component: () => import('@/views/logs/backup/detail')
                                }]

                        },
                        {
                            path: 'analysis',
                            name: 'analysis_logs',
                            meta: { label: 'Tra cứu, tìm kiếm nhật ký đồng bộ dữ liệu', requiresAuth: true, requiresPrivileges: ['ViewBackupLog'] },
                            component: () => import('@/views/logs/analysis/list')
                        },
                        {
                            path: 'report-requests',
                            name: 'report_request_logs',
                            redirect: '/logs/report-requests/list',
                            meta: { label: 'Nhật ký yêu cầu báo cáo', requiresAuth: true },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'report_request_logs_list',
                                    meta: { label: 'Tra cứu, tìm kiếm nhật ký yêu cầu báo cáo', requiresAuth: true, requiresPrivileges: ['ViewReportSyncLog'] },
                                    component: () => import('@/views/logs/request/list')
                                },
                                {
                                    path: ':logId',
                                    name: 'report_request_logs_detail',
                                    meta: { label: 'Xem chi tiết nhật ký yêu cầu báo cáo', requiresAuth: true, requiresPrivileges: ['ViewReportSyncLog'] },
                                    component: () => import('@/views/logs/request/detail')
                                }]

                        },
                        {
                            path: 'search',
                            name: 'logs_search',
                            redirect: '/logs/search/list',
                            meta: { label: 'Theo dõi lịch sử đồng bộ dữ liệu' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'search_asset_sync_logs_list',
                                    meta: { label: 'Tra cứu, tìm kiếm theo dõi lịch sử đồng bộ dữ liệu', requiresAuth: true, adminOnly: true, title: 'Tra cứu, tìm kiếm theo dõi lịch sử đồng bộ dữ liệu' },
                                    component: () => import('@/views/logs/sync/data/list')
                                },
                                {
                                    path: ':logId',
                                    name: 'search_asset_sync_logs_detail',
                                    meta: { label: 'Xem chi tiết theo dõi lịch sử đồng bộ dữ liệu', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/logs/sync/data/detail')
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'help',
                    name: 'help',
                    redirect: '/help/notifications',
                    meta: { label: 'Tiện ích' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'notifications',
                            name: 'help_notifications',
                            redirect: '/help/notifications/asset-info-error',
                            meta: { label: 'Cảnh báo đồng bộ' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'asset-info-error',
                                    name: 'help_notifications_asset_info_error',
                                    redirect: '/help/notifications/asset-info-error/list',
                                    meta: { label: 'Tài sản đồng bộ lỗi' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'help_notifications_asset_info_error_list',
                                            meta: { label: 'Tra cứu, tìm kiếm thông tin tài sản đồng bộ lỗi', unitOption: 0, errorOnly: true, infoTypes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 16, 17, 18, 19, 20, 21], title: 'Tra cứu, tìm kiếm thông tin tài sản đồng bộ lỗi', gridName: 'Danh sách tài sản đồng bộ lỗi', requiresAuth: true, requiresPrivileges: ['ViewAssetSyncError'] },
                                            component: () => import('@/views/logs/sync/assets/list')
                                        },
                                        {
                                            path: ':logId',
                                            name: 'help_notifications_asset_info_error_detail',
                                            meta: {
                                                label: 'Xem chi tiết tài sản đồng bộ lỗi',
                                                title: 'Xem chi tiết tài sản đồng bộ lỗi',
                                                requiresAuth: true,
                                                requiresPrivileges: ['ViewAssetSyncError']
                                            },
                                            component: () => import('@/views/logs/sync/assets/detail')
                                        }
                                    ]
                                },
                                {
                                    path: 'asset-info-subs',
                                    name: 'help_notifications_asset_info_subs',
                                    redirect: '/help/notifications/asset-info-subs/list',
                                    meta: { label: 'Tài sản cấp dưới đồng bộ' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'help_notifications_asset_info_subs_list',
                                            meta: { label: 'Tra cứu , tìm kiếm thông tin tài sản cấp dưới đồng bộ lên hệ thống', infoTypes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 16, 17, 18, 19, 20, 21], title: 'Tra cứu , tìm kiếm thông tin tài sản cấp dưới đồng bộ lên hệ thống', gridName: 'Danh sách tài sản cấp dưới đồng bộ lên hệ thống', requiresAuth: true, requiresPrivileges: ['ViewAssetSyncSub'] },
                                            component: () => import('@/views/logs/sync/assets/list')
                                        },
                                        {
                                            path: ':logId',
                                            name: 'help_notifications_asset_info_subs_detail',
                                            meta: { label: 'Xem chi tiết tài sản cấp dưới đồng bộ', title: 'Xem chi tiết tài sản cấp dưới đồng bộ', requiresAuth: true, requiresPrivileges: ['ViewAssetSyncSub'] },
                                            component: () => import('@/views/logs/sync/assets/detail')
                                        }
                                    ]
                                },
                                {
                                    path: 'asset-exploitation-error',
                                    name: 'help_notifications_asset_exploitation_error',
                                    redirect: '/help/notifications/asset-exploitation-error/list',
                                    meta: { label: 'Khai thác tài sản đồng bộ lỗi' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'help_notifications_asset_exploitation_error_list',
                                            meta: { label: 'Tra cứu, tìm kiếm thông tin hoạt động khai thác tài sản đồng bộ lỗi', unitOption: 0, errorOnly: true, infoTypes: [11, 12, 13, 14, 15], title: 'Tra cứu, tìm kiếm thông tin hoạt động khai thác tài sản đồng bộ lỗi', gridName: 'Danh sách hoạt động khai thác tài sản đồng bộ lỗi', requiresAuth: true, requiresPrivileges: ['ViewAssetExploitationSyncError'] },
                                            component: () => import('@/views/logs/sync/assets/list')
                                        },
                                        {
                                            path: ':logId',
                                            name: 'help_notifications_asset_exploitation_error_detail',
                                            meta: {
                                                label: 'Xem chi tiết khai thác tài sản đồng bộ lỗi', title: 'Xem chi tiết khai thác tài sản đồng bộ lỗi', requiresAuth: true, requiresPrivileges: ['ViewAssetExploitationSyncError']
                                            },
                                            component: () => import('@/views/logs/sync/assets/detail')
                                        }
                                    ]
                                },
                                {
                                    path: 'asset-exploitation-subs',
                                    name: 'help_notifications_asset_exploitation_subs',
                                    redirect: '/help/notifications/asset-exploitation-subs/list',
                                    meta: { label: 'Khai thác tài sản cấp dưới đồng bộ' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'help_notifications_asset_exploitation_subs_list',
                                            meta: { label: 'Tra cứu, tìm kiếm thông tin hoạt động khai thác tài sản cấp dưới đồng bộ lên hệ thống', infoTypes: [11, 12, 13, 14], title: 'Tra cứu, tìm kiếm thông tin hoạt động khai thác tài sản cấp dưới đồng bộ lên hệ thống', gridName: 'Danh sách hoạt động khai thác tài sản cấp dưới đồng bộ lên hệ thống', requiresAuth: true, requiresPrivileges: ['ViewAssetExploitationSyncSub'] },
                                            component: () => import('@/views/logs/sync/assets/list')
                                        },
                                        {
                                            path: ':logId',
                                            name: 'help_notifications_asset_exploitation_subs_detail',
                                            meta: { label: 'Xem chi tiết khai thác tài sản cấp dưới đồng bộ', title: 'Xem chi tiết khai thác tài sản cấp dưới đồng bộ', requiresAuth: true, requiresPrivileges: ['ViewAssetExploitationSyncSub'] },
                                            component: () => import('@/views/logs/sync/assets/detail')
                                        }
                                    ]
                                },
                                {
                                    path: 'report-error',
                                    name: 'help_notifications_report_error',
                                    redirect: '/help/notifications/report-error/list',
                                    meta: { label: 'Báo cáo đồng bộ lỗi' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'help_notifications_report_error_list',
                                            meta: { label: 'Tra cứu, tìm kiếm thông tin báo cáo tài sản đồng bộ lỗi', unitOption: 0, errorOnly: true, title: 'Tra cứu, tìm kiếm thông tin báo cáo tài sản đồng bộ lỗi', gridName: 'Danh sách báo cáo tài sản đồng bộ lỗi', requiresAuth: true, requiresPrivileges: ['ViewReportSyncError'] },
                                            component: () => import('@/views/logs/sync/reports/list')
                                        },
                                        {
                                            path: ':logId',
                                            name: 'help_notifications_report_error_detail',
                                            meta: { label: 'Xem chi tiết báo cáo đồng bộ lỗi', title: 'Xem chi tiết báo cáo đồng bộ lỗi', requiresAuth: true, requiresPrivileges: ['ViewReportSyncError'] },
                                            component: () => import('@/views/logs/sync/reports/detail')
                                        }
                                    ]
                                },
                                {
                                    path: 'report-subs',
                                    name: 'help_notifications_report_subs',
                                    redirect: '/help/notifications/report-subs/list',
                                    meta: { label: 'Báo cáo cấp dưới đồng bộ' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'list',
                                            name: 'help_notifications_report_subs_list',
                                            meta: { label: 'Tra cứu, tìm kiếm thông tin báo cáo tài sản cấp dưới đồng bộ lên hệ thống', title: 'Tra cứu, tìm kiếm thông tin báo cáo tài sản cấp dưới đồng bộ lên hệ thống', gridName: 'Danh sách báo cáo tài sản cấp dưới đồng bộ lên hệ thống', requiresAuth: true, requiresPrivileges: ['ViewReportSyncSub'] },
                                            component: () => import('@/views/logs/sync/reports/list')
                                        },
                                        {
                                            path: ':logId',
                                            name: 'help_notifications_report_subs_detail',
                                            meta: { label: 'Xem chi tiết báo cáo cấp dưới đồng bộ', title: 'Xem chi tiết báo cáo cấp dưới đồng bộ', requiresAuth: true, requiresPrivileges: ['ViewReportSyncSub'] },
                                            component: () => import('@/views/logs/sync/reports/detail')
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'user-manuals',
                            name: 'user-manuals',
                            redirect: '/help/user-manuals/list',
                            meta: { label: 'Tài liệu hướng dẫn sử dụng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'user_manual_list',
                                    meta: { label: 'Tra cứu, tìm kiếm tài liệu hướng dẫn sử dụng', requiresAuth: false, requiresPrivileges: ['ViewUserManual'] },
                                    component: () => import('@/views/help/user-manuals/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_user_manual',
                                    meta: { label: 'Thêm mới tài liệu hướng dẫn sử dụng', requiresAuth: true, requiresPrivileges: ['ManageUserManual'] },
                                    component: () => import('@/views/help/user-manuals/create')
                                },
                                {
                                    path: ':userManualId',
                                    redirect: '/help/user-manuals/:userManualId/detail',
                                    meta: { requiresAuth: true, requiresPrivileges: ['ViewUserManual', 'ManageUserManual'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'user_manual_detail_info',
                                            meta: { label: 'Xem chi tiết tài liệu hướng dẫn sử dụng', requiresAuth: true, requiresPrivileges: ['ViewUserManual', 'ManageUserManual'] },
                                            component: () => import('@/views/help/user-manuals/detail')
                                        },
                                        {
                                            path: 'edit',
                                            name: 'user_manual_edit',
                                            meta: { label: 'Sửa tài liệu hướng dẫn sử dụng', editing: true, requiresAuth: true, requiresPrivileges: ['ViewUserManual', 'ManageUserManual'] },
                                            component: () => import('@/views/help/user-manuals/detail')
                                        }
                                    ]
                                },

                            ]
                        },
                        {
                            path: 'import-users',
                            name: 'import-users',
                            redirect: '/help/import-users/import',
                            meta: { label: 'Import người dùng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'import',
                                    name: 'import_user',
                                    meta: { label: 'Import người dùng', requiresAuth: true, requiresPrivileges: ['ManageUserManual'] },
                                    component: () => import('@/views/help/import-users/create')
                                },
                            ]
                        },
                        {
                            path: 'verify-data',
                            name: 'verify_data',
                            redirect: '/help/verify-data/list',
                            meta: { label: 'Xác nhận dữ liệu' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'list_verify_data',
                                    meta: { label: 'Danh sách đơn vị xác nhận', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/help/verify-data/list')
                                },
                                {
                                    path: 'verify',
                                    name: 'create_verify_data',
                                    meta: { label: 'Xác nhận', requiresAuth: true, topLevelOnly: true },
                                    component: () => import('@/views/help/verify-data/verify')
                                },
                                {
                                    path: ':verifyDataId',
                                    name: 'verify_data_detail',
                                    meta: { label: 'Thông tin xác nhận dữ liệu', requiresAuth: true, adminOnly: true },
                                    component: () => import('@/views/help/verify-data/detail')
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            path: '/access-denied',
            name: 'access-denied',
            component: Page401
        },
        {
            path: '*',
            component: Page404
        }
    ]
})

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (requiresAuth) {
        mgr.getUser().then(user => {
            if (user == null) {
                mgr.signIn(location.href);
            } else {
                var isAuthorized = true;
                for (var i = 0; i < to.matched.length; i++) {
                    var route = to.matched[i];

                    if (route.meta.requiresAuth) {
                        // Check if this route require authentication
                        if (!store.state.identity.isAuthenticated) {
                            isAuthorized = false;
                            break;
                        }
                        // Check if this route require admin permission
                        else if (route.meta.adminOnly && !store.state.identity.isAdmin) {
                            isAuthorized = false;
                            break;
                        }
                        // Check if this route require BTC user only permission
                        else if (route.meta.btcOnly && !store.state.identity.isBTCUser) {
                            isAuthorized = false;
                            break;
                        }
                        // Check if this route require Top level unit only permission
                        else if (route.meta.topLevelOnly && !store.state.identity.isTopLevelUnit) {
                            isAuthorized = false;
                            break;
                        }
                        // Check if this route require certain privileges
                        else if (route.meta.requiresPrivileges && route.meta.requiresPrivileges.length > 0
                            && intersect(store.state.identity.privileges, route.meta.requiresPrivileges).length == 0) {
                            isAuthorized = false;
                            break;
                        }
                    }
                }

                if (isAuthorized) {
                    next();
                } else {
                    if (store.state.identity.isAuthenticated) {
                        next('/access-denied');
                    } else {
                        mgr.signIn(location.href);
                    }
                }
            }
        });
    } else {
        next();
    }

});

export default router;
